import { LayoutOffset } from '../types/layout';

export function commonPaddingClass(offset?: LayoutOffset): string {
  return commonOffsetClass('pad', offset);
}

export function commonGapClass(offset?: LayoutOffset): string {
  return commonOffsetClass('gap', offset);
}

function commonOffsetClass(prefix: string, offset?: LayoutOffset): string {
  return [prefix, offset].filter(c => !!c).join('-');
}
